// extracted by mini-css-extract-plugin
export default {"button":"Button_button__IB27n","arrow":"Button_arrow__7UKBY"};